import ApiService from "@/common/api.service";

const PATH = "stock/sales";

export const GET_STOCK_SALES = "getStockSales";
export const GET_STOCK_SALE = "getStockSale";
export const CREATE_STOCK_SALE = "createStockSale";
export const UPDATE_STOCK_SALE = "updateStockSale";
export const FINALIZE_STOCK_SALE = "finalizeStockSale";
export const CANCEL_STOCK_SALE = "cancelStockSale";
export const DISCARD_STOCK_SALE = "discardStockSale";
export const GET_STOCK_SALE_DRAFT_FROM_SO = "getStockSaleDraftFromSalesOrder";
export const GET_STOCK_SALE_DRAFT_FROM_TO = "getStockSaleDraftFromTransportOrder";
export const GET_STOCK_SALE_SUGGEST_LOTS = "getStockSaleSuggestLots";
export const GET_STOCK_SALE_SUGGEST_DRAFT_LOTS = "getStockSaleSuggestDraftLots";
export const UPLOAD_STOCK_SALE_FILES = "uploadStockSaleFiles";
export const DELETE_STOCK_SALE_FILE = "deleteStockSaleFile";
export const DOWNLOAD_STOCK_SALE_FILE = "downloadStockSaleFile";
export const REGENERATE_STOCK_SALE_DOCUMENT = "regenerateStockSaleDocument";

const actions = {
  [GET_STOCK_SALES](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.query(PATH, {
        ...(params || {}),
        ...context.rootGetters.stockContextFilterParams,
      })
        .then(({ data }) => resolve(data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [GET_STOCK_SALE](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.get(PATH, id)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [CREATE_STOCK_SALE](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.post(PATH, params)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [UPDATE_STOCK_SALE](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.update(PATH, payload.id, payload.params)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [FINALIZE_STOCK_SALE](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${id}/finalize`)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [CANCEL_STOCK_SALE](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${id}/cancel`)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [DISCARD_STOCK_SALE](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${id}/discard`)
        .then(() => resolve(true))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [GET_STOCK_SALE_DRAFT_FROM_SO](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.query(`stock/sales-orders/${payload.id}/delivery-draft`, payload.params || {})
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [GET_STOCK_SALE_DRAFT_FROM_TO](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.query(`stock/transport-orders/${payload.id}/delivery-draft`, payload.params || {})
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [GET_STOCK_SALE_SUGGEST_LOTS](context, payload) {
    const saleId = payload.saleId || payload.id;
    const params = payload.params || {};

    return new Promise((resolve, reject) => {
      ApiService.query(`${PATH}/${saleId}/suggest-lots`, params)
        .then(({ data }) => resolve(data.data || data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [GET_STOCK_SALE_SUGGEST_DRAFT_LOTS](context, payload) {
    const params = (payload && payload.params) || {};

    return new Promise((resolve, reject) => {
      ApiService.query(`${PATH}/suggest-lots`, params)
        .then(({ data }) => resolve(data.data || data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [UPLOAD_STOCK_SALE_FILES](context, payload) {
    const formData = new FormData();
    (payload.files || []).forEach((file) => formData.append("files[]", file));

    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${payload.id}/files`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [DELETE_STOCK_SALE_FILE](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.delete(`${PATH}/${payload.id}/files/${payload.fileId}`)
        .then(() => resolve(true))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [DOWNLOAD_STOCK_SALE_FILE](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.downloadFile(
        `${PATH}/${payload.id}/files/${payload.fileId}/download`,
        payload.originalName || payload.name || "download"
      )
        .then(() => resolve(true))
        .catch((error) => reject(error?.response?.data || error));
    });
  },

  [REGENERATE_STOCK_SALE_DOCUMENT](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${id}/regenerate-document`)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },
};

export default {
  state: {},
  getters: {},
  actions,
  mutations: {},
};
